import { WebSocketClient } from "./WebSocketClient";
import { SocketAck } from "./SocketAck";
import { HashTable } from "../HashTable";

import { SocketDelegate } from "./SocketDelegate";

function SocketClient() {
    this.ip;
    this.port;
    this.operator;
    this.socket; //具体的socket对象，这边实现的是websocket
    this.socketAck;
    this.events; //注册的事件列表，应答方法从这里面根据key寻找
    this.eventType = {
        onGetVelLastGPSExAck: 0x114, //查询车辆最后一点位置   
        onTakePhotoAck: 0x17, //图片抓拍应答
        onReceivePhoto: 0x18, //图片抓拍进度汇报
        onReceivePhotoComplete: 0x19, //图片抓拍结束
        onReceiveMultiMediaAbnormal: 0x56, //用于web端处理多媒体传输情况请求信息
        onQueryResourceListAck: 0x010511, //查询视频资源文件
        onRemoteVideoReplayAck: 0x010512,//视频播放应答
        onRemoteVideoReplayControlAck: 0x010513,//视频控制应答
        onRealTimeMultiMediaDeviceTransferAck: 0x01050E,
        onMultiMediaDeviceRealTimeTransferControlAck: 0x01050F,
        onQueryMultiMediaDeviceParamAck: 0x01050D,
        onSendInfomationAck: 0x01050D,//消息发送应答
        onVelOnlineStateAck: 0x69,//查询车辆在线状态应答
        onMultiMediaFileUploadAck: 0x010514,//1078协议 多媒体文件上传指令应答 0x9206
        // onMultiMediaFileUploadCompleteAck: 0x01050122,//1078协议 多媒体文件上传完成通知 0x1204
    }; //事件类型

    this.socketTimeHandler; //socket定时器
    this.connectTimeHandler; //连接定时器

    this.inited=false;

    //初始化socketClient ，在main.js里面进行
    this.init = (ip, port, operator) => {

        if(this.inited)return;
        this.ip = ip;
        this.port = port;
        this.operator = operator;
        // console.log("初始化");
        this.events = new HashTable(); //注册的事件列表，应答方法从这里面根据key寻找

        this.initEvent(); //初始化事件

        this.socketAck = new SocketAck(this.events, this.eventType);

        this.socketAck.onDisConnect = this.onDisConnect;

        this.initSocket();

        this.inited=true;
    };

    (this.onDisConnect = () => {
        this.initSocket();
    }),
        (this.initSocket = () => {
            this.socket = new WebSocketClient(this.socketAck);
            //初始化socket，连接websocket，登录
            this.socket.init(this.ip, this.port, this.operator);
        });

    this.initEvent = () => {
        for (var k in this.eventType) {
            this.events.add(this.eventType[k], new SocketDelegate());
        }
    };

    /**注册事件 */
    this.AttachEvent = (target, eventType, callBack) => {
        if (
            typeof target != "undefined" &&
            typeof eventType != "undefined" &&
            typeof callBack != "undefined"
        ) {
            if (this.events.contains(eventType)) {
                this.events.items(eventType).add(target, callBack);
            }
        }
    };
    /**取消事件 */
    this.DetachEvent = (target, eventType, callBack) => {
        if (typeof target != "undefined" && typeof eventType != "undefined") {
            if (
                this.events.contains(eventType) &&
                this.events.items(eventType).eventList.contains(target)
            ) {
                this.events.items(eventType).remove(target);
            }
        }
    };

    /*
      功能描述：创建时钟
      参数说明：target:接收事件模块名称；eventType:事件名称
      返回：无
      */
    this.createInterval = (funcName, time) => {
        var args = [];
        for (var i = 2; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return window.setInterval(function () {
            funcName.apply(this, args);
        }, time);
    };
}

export { SocketClient };
